export default __webpack_public_path__ + "static/media/Fantasy_15.cf954a51.png";